import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'pro-loading-dots',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-dots.component.html',
  styleUrls: ['./loading-dots.component.css']
})
export class LoadingDotsComponent {
  size = input<string>('.3rem')
}
